export const SUPPORT_LAUNCH_ENVELOPES_FUNDRAISING_URL =
    'https://support.givelify.com/hc/en-us/sections/1500000456461-Launch-Envelopes-and-Fundraising';
export const SUPPORT_ADD_PRIMARY_REP_URL = 'https://giv.li/t0ow5h';
export const SUPPORT_WHY_PRIMARY_REP_URL = 'https://giv.li/0tni9i';
export const SUPPORT_TERMS_OF_USE_URL =
    'https://www.givelify.com/about/terms-of-use/';
